import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { ConfirmDialogComponent } from 'src/app/modules/shared/confirm-dialog/confirm-dialog.component';

@Injectable({
  providedIn: 'root',
})
export class DialogService {

  constructor(private modalService: NgbModal) {}

  /*
    Prompt a confirmation dialog.
  */
  async askConfirmation(content: string, title?: string) {
    const modal = this.modalService.open(ConfirmDialogComponent, {
      centered: true,
    });

    modal.componentInstance.content = content;
    modal.componentInstance.title = title ?? 'Confirm';

    return await modal.result;
  }
}
